import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'c-dashboard-employee',
  templateUrl: './dashboard-employee.component.html',
  styleUrls: ['./dashboard-employee.component.scss']
})
export class DashboardEmployeeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
